// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7fe2cced","171":"41438d2e","227":"e6499443","402":"2d794c5f","453":"2c88876b","648":"a6a988cb","783":"fc247bfb","903":"dd06eaa5","923":"e617499a"}[chunkId] + ".chunk.js";
};